export const selectDetailView = (state) => state?.contracts.detail;

export const selectContractDetail = (state) =>
  state?.contracts?.detail?.contract;

export const selectCurrentContractName = (state) =>
  state?.contracts?.detail?.contract?.contractName;

export const selectCurrentContractId = (state) =>
  state?.contracts?.detail?.contract?.id;

export const selectContractDocuments = (state) =>
  state?.contracts?.detail?.documents || [];

export const selectIsContractLoading = (state) =>
  state?.contracts?.detail?.isLoading;

export const selectIsContractArchived = (state) =>
  Boolean(state?.contracts?.detail?.contract?.archivedAt);
